import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/dist/ScrollTrigger';
import ScrollToPlugin from 'gsap/dist/ScrollToPlugin';
class StickyNav extends Component {
  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      mediaGallery: document.querySelector<HTMLElement>('.media-gallery'),
      anchorLinks: this.el.querySelectorAll<HTMLElement>('.sticky-nav__anchor'),
      sectionModules: document.querySelectorAll<HTMLElement>('.sticky-module'),
      goToBtn: document.querySelector<HTMLElement>('.btn.btn--primary'),
      closeAlertBanner: document.querySelector<HTMLElement>('.alert-banner-close-button')
    };

    const observer = new IntersectionObserver(this.detectVisibleGallery.bind(this), {
      rootMargin: '-164px 0px 0px 0px'
    });
    observer.observe(this.dom.mediaGallery as HTMLElement);
    this.initializeGSAP();
  }

  addListeners() {
    (this.dom.anchorLinks as NodeList).forEach(link => {
      link.addEventListener('click', this.scrollToSection.bind(this));
    });
    (this.dom.goToBtn as HTMLElement).addEventListener('click', this.scrollToSection.bind(this));

    if (this.dom.closeAlertBanner) {
      (this.dom.closeAlertBanner as HTMLElement).addEventListener('click', this.updateTop.bind(this));
    }
  }

  updateTop() {
    (this.dom.el as HTMLElement).style.insetBlockStart = `99px`;
  }

  detectVisibleGallery(entries: IntersectionObserverEntry[]) {
    const alertBanner = document.querySelector('.alert-banner');
    const startTopValue = 99;

    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        (this.dom.el as HTMLElement).classList.add('show');
        if (alertBanner) {
          const alertBannerHeight = (alertBanner as HTMLElement).offsetHeight;
          (this.dom.el as HTMLElement).style.insetBlockStart = `${startTopValue + alertBannerHeight}px`;
        } else {
          (this.dom.el as HTMLElement).style.insetBlockStart = `${startTopValue}px`;
        }
        // ScrollTrigger.refresh();
      } else {
        (this.dom.el as HTMLElement).classList.remove('show');
      }
    });
  }

  scrollToSection(e: Event) {
    e.preventDefault();
    const target = e.target as HTMLAnchorElement;
    const yOffset = -164;
    const element = document.getElementById(`${target.href.split('#')[1]}`);
    const targetPosition = (element as HTMLElement).getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: targetPosition, behavior: 'auto' });
  }

  initializeGSAP() {
    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    ScrollTrigger.config({
      autoRefreshEvents: 'visibilitychange, DOMContentLoaded, load, resize'
    });

    const links = [...(this.dom.anchorLinks as NodeList)];
    const sections = [...(this.dom.sectionModules as NodeList)];

    links.forEach(link => {
      link.addEventListener('click', () => {
        for (let i = 0; i < (this.dom.anchorLinks as NodeList)?.length; i++) {
          const prev = links;
          if ((prev[i] as HTMLElement).classList.contains('active')) {
            (prev[i] as HTMLElement).classList.remove('active');
          }
        }
        (link as HTMLElement).classList.add('active');
      });
    });

    sections.forEach((section, index) => {
      ScrollTrigger.create({
        trigger: section as HTMLElement,
        start: 'top center',
        end: 'bottom center',
        onToggle: self => {
          if (self.isActive) {
            (links[index] as HTMLElement).classList.add('active');
          } else {
            (links[index] as HTMLElement).classList.remove('active');
          }
        }
      });
    });
  }
}

export default StickyNav;
